import React, { useState, useEffect, useReducer } from 'react'
import { Button } from '@material-ui/core'
import AddressSearchBar from '../components/AddressSearchBar'
import LoadingPanel from '../components/table/LoadingPanel'
import SearchBar from '../components/SearchBar'
import Geocode from 'react-geocode'
import Map from '../components/Map'
import Marker from '../components/Marker'
import MileSearchBar from '../components/MileSearchBar'
import { getLatLongApiCall, updateGeocodeApiCall, emailApiCall } from '../service/client'
import { connect } from 'react-redux'
import actions from '../reducers/actions'
import Navigation from '../components/Navigation'
import { OFFICE_USER } from '../constants/permissions.json'
import { Redirect } from 'react-router-dom'
import '../map.css'

function distance(lat1, lon1, lat2, lon2) {
  const p = 0.017453292519943295
  const c = Math.cos
  const a = 0.5 - c((lat2 - lat1) * p) / 2 +
    c(lat1 * p) * c(lat2 * p) *
    (1 - c((lon2 - lon1) * p)) / 2
  return 7917.6 * Math.asin(Math.sqrt(a))
}

const emptyAddress = [{ value: { lat: 0, lng: 0 }, label: '' }]
const emptyCrews = { 0: '', 1: '', 2: '' }
const emptyCrewAddresses = { 0: emptyAddress, 1: emptyAddress, 2: emptyAddress }
const emptyManagers = { 0: '', 1: '', 2: '', 3: '', 4: '', 5: '' }
const emptyManagerAddresses = { 0: emptyAddress, 1: emptyAddress, 2: emptyAddress, 3: emptyAddress, 4: emptyAddress, 5: emptyAddress }
const crewFlags = ['Clear Walks', 'Plow Parking Deck', 'Plow Lot']

function MapPage({ user, logout, endImpersonation, setOverrideUrl }) {
  const [routeInfo, setRouteInfo] = useState([])
  const [crewInfo, setCrewInfo] = useState([])
  const [crews, setCrews] = useState(emptyCrews)
  const [crewAddresses, setCrewAddresses] = useState(emptyCrewAddresses)
  const [managerInfo, setManagerInfo] = useState([])
  const [managers, setManagers] = useState(emptyManagers)
  const [managerAddresses, setManagerAddresses] = useState(emptyManagerAddresses)
  const [nearMarkers, setNearMarkers] = useState([])
  const [searchMarker, setSearchMarker] = useState([])
  const [searchDistance, setSearchDistance] = useState(0)
  const [searchLocation, setSearchLocation] = useState({ value: { lat: 0, lng: 0 }, label: 'Search' })
  const [prospects, setProspects] = useState([])
  const [prospectDistance, setProspectDistance] = useState(0)
  const [allMapped, setAllMapped] = useState(false)
  const [loadingRoutes, setLoadingRoutes] = useState(false);

  const reducer = (state, action) => {
    return [...action, ...state]
  }
  const [addresses, setAddresses] = useReducer(reducer, [{ value: '', label: '' }])

  function compareOptions(a, b) {
    const valueA = a.label.toUpperCase()
    const valueB = b.label.toUpperCase()
    let comp = 0
    if (valueA > valueB) {
      comp = 1
    }
    if (valueA < valueB) {
      comp = -1
    }
    return comp
  }

  useEffect(() => {
    loadData()
  }, [user.overrideUrl])

  function loadData() {
    setLoadingRoutes(true)
    getLatLongApiCall(user).then(({ body }) => {
      const invalidRoutes = []
      const filteredBody = body.filter(b => b.Longitude !== 0.1).map(route => {
        return {
          ...route,
          displayCrewName: crewFlags.includes(route.Prod_ServiceDesc) ? `${route.Prod_ServiceDesc}: ${route.CrewName}` : null,
          acres: route.UnitofMeasure_idd === 1 ? `Acres: ${route.SurfaceSize}` : null
        }
      })
      setRouteInfo(filteredBody)
      const areaManagers = []
      const crews = []
      const crewIdds = []
      const newAddresses = new Set()
      const addressIds = []
      const updateRoutes = []
      const updateRouteIds = []
      filteredBody.map((route) => {
        if (route.AreaManager) {
          areaManagers.push(route.AreaManager)
        }

        if (route.CrewIdd && !crewIdds.includes(route.CrewIdd)) {
          crewIdds.push(route.CrewIdd)
          crews.push({ value: route.CrewIdd, label: route.CrewName })
        }

        if (!route.Longitude && !updateRouteIds.includes(route.PropID)) {
          updateRouteIds.push(route.PropID)
          if (route.Address) {
            updateRoutes.push({ PropID: route.PropID, Address: route.Address, route: route })
          } else if (route.PropAddress && route.PropZip) {
            updateRoutes.push({ PropID: route.PropID, Address: `${route.PropAddress}, ${route.PropZip}`, route: route })
          }
        }

        if (route.Address && !addressIds.includes(route.PropID)) {
          addressIds.push(route.PropID)
          if (route.PropAddress) {
            newAddresses.add([route.Address, route.PropAddress, route.PropZip, route.Latitude, route.Longitude, route.PropID, route.PropName])
          } else {
            newAddresses.add([route.Address, route.PropName, route.PropZip, route.Latitude, route.Longitude, route.PropID])
          }
        }
      })

      setAddresses([...newAddresses].map((address) => (
        {
          value: {
            address: address[0],
            lat: address[3],
            lng: address[4],
            name: address[6],
            id: address[5]
          },
          label: `${address[6]}`
        })
      ).sort(compareOptions))

      if (updateRoutes.length > 0) {
        const geocodeArr = []
        updateRoutes.forEach((route) => geocodeArr.push(addGeocode(route.PropID, route.Address, route.route)))
        Promise.all(geocodeArr).then(rtn => {
          if (invalidRoutes.length > 0) {
            emailErrors()
          }
        })
      }

      function addGeocode(PropID, address, route) {
        Geocode.setApiKey('AIzaSyAd66nhKM02FkrMGisUp_QKwUK6WOFebWY')
        Geocode.setRegion('us')

        function googleGeocode() {
          return Geocode.fromAddress(address).then(
            response => {
              if (response.status === 'OK') {
                const { lat, lng } = response.results[0].geometry.location
                return setGeocode({ PropID: PropID, Latitude: lat, Longitude: lng })
              } else {
                invalidRoutes.push(route)
                return setGeocode({ PropID: PropID, Latitude: 0.1, Longitude: 0.1 })
              }
            },
            error => {
              console.error(error)
              invalidRoutes.push(route)
              return setGeocode({ PropID: PropID, Latitude: 0.1, Longitude: 0.1 })
            }
          )
        }

        return googleGeocode()

        function setGeocode(obj) {
          updateGeocodeApiCall(user, obj.PropID, obj.Latitude, obj.Longitude).then((res) => {
            const { Address, Latitude, Longitude, PropName } = res.body[0]
            setAddresses(
              [{
                value: {
                  address: Address,
                  lat: Latitude,
                  lng: Longitude,
                  name: PropName
                },
                label: `${PropName}`
              }]
            )
            return res
          }).catch(console.log)
        }
      }

      function emailErrors() {
        const subject = 'Route Address Errors'
        let errorRouteHtml = 'The following property addresses generated Google errors: <br />'
        let errorRouteText = 'The following property addresses generated Google errors: '
        for (const route of invalidRoutes) {
          const { PropID, Property, Address, PropAddress, PropCity, PropState, PropZip } = route
          errorRouteHtml += `<br />ID: ${PropID}<br />
					Property: ${Property}<br />
					Address: ${Address}<br />
					PropAddress: ${PropAddress}<br />
					City: ${PropCity}<br />
					State: ${PropState}<br />
					Zip: ${PropZip}<br />`
          errorRouteText += `
					ID: ${PropID}
					Property: ${Property}
					Address: ${Address}
					PropAddress: ${PropAddress}
					City: ${PropCity}
					State: ${PropState}
					Zip: ${PropZip}
					`
        }

        emailApiCall(user, subject, errorRouteText, errorRouteHtml)
      }

      setCrewInfo(crews.sort(compareOptions))
      setManagerInfo([...new Set(areaManagers)].map((manager) => ({
        value: manager,
        label: manager
      })).sort(compareOptions))
      setLoadingRoutes(false);
    })
  }

  function findLocations(id, comparison, allFlag) {
    const locations = []
    const routes = allFlag ? routeInfo : routeInfo.filter(r => r[comparison] === id)
    const groupedRoutes = {}
    for (const r of routes) {
      if (groupedRoutes[r.PropID]) {
        groupedRoutes[r.PropID].push(r)
      } else {
        groupedRoutes[r.PropID] = [r]
      }
    }

    for (const id of Object.keys(groupedRoutes)) {
      const crewNames = new Set()
      groupedRoutes[id].forEach(service => {
        if (service.displayCrewName) {
          crewNames.add(service.displayCrewName)
        }
      })
      const route = groupedRoutes[id][0]
      locations.push(
        {
          value: {
            address: route.Address,
            lat: route.Latitude,
            lng: route.Longitude,
            name: route.PropName,
            id: route.PropID,
            crewNames: [...crewNames],
            acres: route.acres
          },
          label: `${route.PropName}`
        }
      )
    }

    return locations
  }

  function nearbyLocations(location, addresses, miles) {
    const nearbyMarkers = []
    const nearbyIds = []
    addresses.forEach(address => {
      const seperation = distance(address.value.lat, address.value.lng, location.lat, location.lng)
      if (seperation <= miles) {
        nearbyIds.push(address.value.id)
      }
    })
    nearbyIds.forEach((id, idx) => {
      findLocations(id, 'PropID').map((address, i) => nearbyMarkers.push(makeMarker(address, 'yellow', `${idx}-${i}`, 'nearby')))
    })
    setNearMarkers(nearbyMarkers)
  }

  function clearNearbyMarkers() {
    setNearMarkers([])
  }

  function clearSearchMarker() {
    setSearchMarker([])
  }

  function clearCrewMarkers() {
    setCrews(emptyCrews)
    setCrewAddresses(emptyCrewAddresses)
  }

  function clearManagerMarkers() {
    setManagers(emptyManagers)
    setManagerAddresses(emptyManagerAddresses)
  }

  function addProspect(newProspect) {
    setProspects([...prospects, newProspect])
  }

  function removeProspect(idx) {
    setProspects(prospects.filter((p, i) => i !== idx))
  }

  function clearProspects() {
    setProspects([])
  }

  function selectAddress() {
    if (searchLocation && searchLocation.value.lat) {
      const location = findLocations(searchLocation.value.id, 'PropID')[0]
      setSearchMarker(makeMarker(location, 'purple', 125, 'location'))
    }
  }

  function mapAll() {
    const locations = findLocations('', 'PropID', true)
    setAllMapped(true)
    setSearchMarker(locations.map((location, idx) => makeMarker(location, 'purple', idx, 'location')))
  }

  function clearAll() {
    setSearchMarker([])
    setAllMapped(false)
  }

  useEffect(() => {
    clearSearchMarker()
    selectAddress()
  }, [searchLocation])

  function findNearby() {
    if (!searchLocation || searchLocation.value.lat === 0) {
      alert('Location not found.  Click the Reload button and try again or verify the address is valid in Snow Management.')
    } else {
      nearbyLocations(searchLocation.value, addresses, searchDistance.value)
    }
  }

  function findNearProspects() {
    const nearbyMarkers = []
    const nearbyIds = []

    prospects.forEach(p => {
      addresses.forEach(address => {
        const seperation = distance(address.value.lat, address.value.lng, p.value.lat, p.value.lng)
        if (seperation <= prospectDistance.value) {
          nearbyIds.push(address.value.id)
        }
      })
    })
    nearbyIds.forEach((id, idx) => {
      findLocations(id, 'PropID').map((address, i) => nearbyMarkers.push(makeMarker(address, 'yellow', `${idx}-${i}`, 'nearby')))
    })
    setNearMarkers(nearbyMarkers)
  }

  function makeMarker(address, color, idx, type, clickDisabled) {
    return (
      <Marker
        lat={address.value.lat}
        lng={address.value.lng}
        address={address}
        key={`${color}${idx}${type}`}
        color={color}
        setSearchLocation={setSearchLocation}
        clickDisabled={clickDisabled}
        type={type}
      />
    )
  }
  const idxColors = ['red', 'blue', 'orange', 'green', 'brown', 'pink', 'crimson', 'coral', 'aqua', 'gold', 'olive', 'lime', 'navy', 'indigo', 'magenta']
  const crewColors = idxColors.slice(0, 3)
  const managerColors = idxColors.slice(4, 10)
  const prospectColors = idxColors.slice(11, 14)
  const idxLabels = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth']

  function handleSetCrewAddresses() {
    const crewAddresses = {}
    for (const key of Object.keys(crews)) {
      crewAddresses[key] = findLocations(crews[key].value, 'CrewIdd')
    }
    setCrewAddresses(crewAddresses)
  }

  function handleSetManagerAddresses() {
    const managerAddresses = {}
    for (const key of Object.keys(managers)) {
      managerAddresses[key] = findLocations(managers[key].value, 'AreaManager')
    }
    setManagerAddresses(managerAddresses)
  }

  const markers = [
    ...Object.keys(crewAddresses).map((key, colorIdx) => {
      return crewAddresses[key].map((address, idx) => makeMarker(address, crewColors[colorIdx], idx, 'crew'))
    }).flat(),
    ...Object.keys(managerAddresses).map((key, colorIdx) => {
      return managerAddresses[key].map((address, idx) => makeMarker(address, managerColors[colorIdx], idx, 'manager'))
    }).flat(),
    ...prospects.map((address, idx) => makeMarker(address, prospectColors[idx] || 'black', idx, 'prospect', true))
  ]

  const distanceOptions = [
    { value: .5, label: '.5' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 20, label: '20' },
    { value: 25, label: '25' },
  ]

  const prospectsDisplay = prospects.map((p, i) => {
    return (
      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: 5, background: 'white', margin: 5, color: prospectColors[i] || 'black' }}>
        <div>{p.label}</div>
        <div style={{ cursor: 'default' }} onClick={() => removeProspect(i)}>X</div>
      </div>
    )
  })

  function setCrew(value, key) {
    const mCopy = JSON.parse(JSON.stringify(crews))
    mCopy[key] = value
    setCrews(mCopy)
  }

  const crewInputs = Object.keys(crews).map(m => {
    return (
      <>
        <h3 style={{ color: crewColors[m] }}>{idxLabels[m]} Crew</h3>
        <div style={{ border: `1px solid ${crewColors[m]}` }}>
          <SearchBar searchValue={crews[m]} setSearchValue={(e) => setCrew(e, m)} options={crewInfo} />
        </div>
      </>
    )
  })

  function setManager(value, key) {
    const mCopy = JSON.parse(JSON.stringify(managers))
    mCopy[key] = value
    setManagers(mCopy)
  }

  const managerInputs = Object.keys(managers).map(m => {
    return (
      <>
        <h3 style={{ color: managerColors[m] }}>{idxLabels[m]} Manager</h3>
        <div style={{ border: `1px solid ${managerColors[m]}` }}>
          <SearchBar searchValue={managers[m]} setSearchValue={(e) => setManager(e, m)} options={managerInfo} />
        </div>
      </>
    )
  })

  return loadingRoutes ? (
    <LoadingPanel />
  ) : user.permissions.includes(OFFICE_USER) ? (
    <div>
      <Navigation logout={() => logout(user)} user={user} endImpersonation={endImpersonation} setOverrideUrl={setOverrideUrl} />
      <div style={{ display: 'flex', marginTop: '64px' }}>
        <div style={{ width: '300px', padding: '10px', height: 'calc(100vh - 84px)', overflow: 'scroll' }}>
          <div>
            <h3 style={{ color: 'purple', display: 'flex', justifyContent: 'space-between' }}>
              <div>Location</div>
              <Button
                onClick={allMapped ? clearAll : mapAll}
                variant='contained'
                style={{ height: 18 }}
              >
                {allMapped ? 'Clear' : 'Map All'}
              </Button>
            </h3>
            <div style={{ border: '1px solid purple', marginBottom: '5px' }}>
              <SearchBar
                searchValue={searchLocation}
                setSearchValue={setSearchLocation}
                options={addresses}
                type="location"
              />
            </div>
            <div style={{ border: '1px solid yellow' }}>
              <MileSearchBar
                searchValue={searchDistance}
                setSearchValue={setSearchDistance}
                placeholder="Select Distance"
                options={distanceOptions}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <Button
                onClick={findNearby}
                style={{ margin: '10px' }}
                size="small"
                variant="outlined"
              >
                Find Nearby
              </Button>
              <Button
                onClick={clearNearbyMarkers}
                style={{ margin: '10px' }}
                size="small"
                variant="outlined"
              >
                Clear Nearby
              </Button>
            </div>
          </div>
          {crewInputs}
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Button
              style={{ margin: '10px' }}
              onClick={handleSetCrewAddresses}
              size="small"
              variant="outlined"
            >
              Map It
            </Button>
            <Button
              style={{ margin: '10px' }}
              onClick={clearCrewMarkers}
              size="small"
              variant="outlined"
            >
              Clear Crews
            </Button>
          </div>
          {managerInputs}
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Button
              style={{ margin: '10px' }}
              onClick={handleSetManagerAddresses}
              size="small"
              variant="outlined"
            >
              Map It
            </Button>
            <Button
              style={{ margin: '10px' }}
              onClick={clearManagerMarkers}
              size="small"
              variant="outlined"
            >
              Clear Managers
            </Button>
          </div>
          <h3>Prospects</h3>
          <div style={{ background: '#fafafa', height: 150, overflow: 'scroll', border: '2px solid black' }}>
            {prospectsDisplay}
          </div>
          <AddressSearchBar addProspect={addProspect} />
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Button
              style={{ margin: '10px' }}
              onClick={clearProspects}
              size="small"
              variant="outlined"
            >
              Clear Prospects
            </Button>
            <Button
              style={{ margin: '10px' }}
              onClick={loadData}
              size="small"
              variant="outlined"
            >
              Reload
            </Button>
          </div>
          <div style={{ border: '1px solid yellow' }}>
            <MileSearchBar
              searchValue={prospectDistance}
              setSearchValue={setProspectDistance}
              placeholder="Select Distance"
              options={distanceOptions}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Button
              onClick={findNearProspects}
              style={{ margin: '10px' }}
              size="small"
              variant="outlined"
            >
              Find Nearby
            </Button>
            <Button
              onClick={clearNearbyMarkers}
              style={{ margin: '10px' }}
              size="small"
              variant="outlined"
            >
              Clear Nearby
            </Button>
          </div>
        </div>
        <div style={{ width: 'calc(100vw - 300px)', height: 'calc(100vh - 64px)' }}>
          <Map
            markers={markers}
            nearMarkers={nearMarkers}
            searchMarker={searchMarker}
            setSearchLocation={setSearchLocation}
          />
        </div>
      </div>
    </div>
  ) : <Redirect to="/" />
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default connect(mapStateToProps, actions)(MapPage)